import { isNotNil, setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./ResultSectionLayout.module.less";
import { localize } from "client_legacy/ndaw/culture";
import { ButtonBase } from "client/Components";

export type ResultSectionLayoutProps = {
	title: string;
	onClearAll?: () => void;
	trackingId: string;
};

export const ResultSectionLayout = (props: PropsWithChildren<ResultSectionLayoutProps>): ReactElement => {
	const {
		title,
		onClearAll,
		trackingId,
		children
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div className={styles.header}>
				<h4
					{...setTrackingId("name")}
					className={styles.title}
				>
					{title}
				</h4>
				<hr className={styles.line} />
				{isNotNil(onClearAll) && (
					<ButtonBase
						trackingId="clear-all"
						onClick={() => onClearAll()}
						className={styles.clearAll}
					>
						{localize("_ClearAll")}
					</ButtonBase>
				)}
			</div>
			{children}
		</div>
	);
};
ResultSectionLayout.displayName = "ResultSectionLayout";

const ResultSectionLayoutList = (props: PropsWithChildren<{}>): ReactElement => {
	return (
		<ul className={styles.list}>
			{props.children}
		</ul>
	);
};
ResultSectionLayoutList.displayName = "ResultSectionLayout.List";

ResultSectionLayout.List = ResultSectionLayoutList;